export default "__VITE_ASSET__wAozAHVk__"